export default "__VITE_ASSET__C_451153__"